import React, { useState } from "react";
import Button from '@mui/material/Button';
import LPJourneyCard from "./LPJourneyCard";
import { useMediaQuery, useTheme } from "@mui/material";
import LPJourneyCardsm from "./LPJourneyCardsm";
import UserOne from './images/UserOne.webp';
import UserTwo from './images/UserTwo.webp';
import UserThree from './images/UserThree.webp';
import UserFour from '../components/images/Amar.webp';
import UserFive from '../components/images/Renoy.webp';
import CareerTransitionCard from "../components/CareerTransitionCard";
import FSDUserOne from '../FullStack/images/FSDUser1.webp';
import FSDUserTwo from '../FullStack/images/FSDUser2.webp';
import FSDUserThree from '../FullStack/images/FSDUser3.webp';
import FSDUserFour from '../FullStack/images/FSDUser4.webp';
import { FULL_STACK } from "../FullStack/FSConstants";


export default function LPJourney(props) {
    const { course } = props;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [user, setUser] = useState(1);

    const handleUser = () => {
        if (user === 1) {
            setUser(2);
        } else if (user === 2) {
            setUser(3);
        } else if (user === 3) {
            setUser(4);
        } else if (user === 4) {
            setUser(5);
        } else {
            setUser(1);
        }
    }

    return (
        <React.Fragment>
            <div style={{ textAlign: "center", marginTop: "4rem" }}>
                <div >
                    <span className={isSmallScreen ? "only-heading-sm" : "only-heading"}>Milestone </span>
                    <span className={isSmallScreen ? "gradient-heading-sm" : "gradient-heading"} >Achieved</span>
                </div>
            </div>
            {isSmallScreen ?
                <>
                    {user === 1 ?
                        <LPJourneyCardsm
                            isSmallScreen={isSmallScreen}
                            src={course === FULL_STACK ? FSDUserOne : UserOne}
                            from={course === FULL_STACK ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQx-pegq80l4gq735EXB7CICD3k0t2A_WvHvQ&s" : "https://companieslogo.com/img/orig/TCS.NS-7401f1bd.png?t=1720244494"}
                            to={course === FULL_STACK ? "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Accenture.svg/2560px-Accenture.svg.png" : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwDXsg8rJ70v4NtXi5ISdEFjgqxChaMgqQvA&s"}
                            name={course === FULL_STACK ? "Pratham Saroch" :"Prachi Sengupta"}
                            hike={120}
                            course={course}
                        />
                        :
                        user === 2 ?
                            <LPJourneyCardsm
                                isSmallScreen={isSmallScreen}
                                src={course === FULL_STACK ? FSDUserTwo : UserTwo}
                                from={course === FULL_STACK ? "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Capgemini_201x_logo.svg/2560px-Capgemini_201x_logo.svg.png" : "https://companieslogo.com/img/orig/MPHASIS.NS_BIG-96e12b36.png?t=1720244492"}
                                to={course === FULL_STACK ? "https://companieslogo.com/img/orig/LTIM.NS-dea59dc6.png?t=1720244492" : "https://purepng.com/public/uploads/large/purepng.com-oracle-logologobrand-logoiconslogos-251519939873wlyup.png"}
                                name={course === FULL_STACK ? "Akanksha Singh" : "Aditya Venkatraman"}
                                hike={90}
                                course={course}
                            />
                            :
                            user === 3 ?
                                <LPJourneyCardsm
                                    isSmallScreen={isSmallScreen}
                                    src={course === FULL_STACK ? FSDUserThree : UserFour}
                                    from={course === FULL_STACK ? "https://companieslogo.com/img/orig/WIT-1453b096.png?t=1739861069" : "https://cdn.cookielaw.org/logos/628cd4f6-e459-4c91-8719-a9557855ad5c/64add6b2-304e-4af7-b8c2-8a925585cf8a/a07269fc-954a-4971-b1f6-ac7acd7aa2fe/FactSet_Logo_CMYK_Cyan.png"}
                                    to={course === FULL_STACK ? "https://www.freelogovectors.net/wp-content/uploads/2022/07/persistent-systems-logo-freelogovectors.net_.png" : "https://upload.wikimedia.org/wikipedia/commons/6/64/Intel-logo-2022.png"}
                                    name={course === FULL_STACK ? "Vivek Pandey" : "Amar Patel"}
                                    hike={83}
                                    course={course}
                                />
                                :
                                user === 4 ?
                                    <LPJourneyCardsm
                                        isSmallScreen={isSmallScreen}
                                        src={course === FULL_STACK ? FSDUserFour : UserFive}
                                        from={"https://clarity.microsoft.com/case-studies/wp-content/uploads/2022/11/Softr-Logo-Colour-Dark.png"}
                                        to={"https://gallerypng.com/wp-content/uploads/2024/05/tata-motors-logo-png-image.png"}
                                        name={course === FULL_STACK ? "Rajeev M" : "Renoy"}
                                        hike={65}
                                        course={course}
                                    />
                                    :
                                    <LPJourneyCardsm
                                        isSmallScreen={isSmallScreen}
                                        src={UserThree}
                                        from={"https://dxminds.com/wp-content/uploads/2020/05/Logo-DxMinds.png"}
                                        to={"https://seeklogo.com/images/C/cred-club-logo-3BD639F47C-seeklogo.com.png"}
                                        name={"Rohan Shinde"}
                                        hike={70}
                                        course={course}
                                    />
                    }
                </>
                :
                <>
                    {user === 1 ?
                        <LPJourneyCard
                            isSmallScreen={isSmallScreen}
                            src={course === FULL_STACK ? FSDUserOne : UserOne}
                            from={course === FULL_STACK ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQx-pegq80l4gq735EXB7CICD3k0t2A_WvHvQ&s" : "https://companieslogo.com/img/orig/TCS.NS-7401f1bd.png?t=1720244494"}
                            to={course === FULL_STACK ? "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Accenture.svg/2560px-Accenture.svg.png" : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwDXsg8rJ70v4NtXi5ISdEFjgqxChaMgqQvA&s"}
                            name={course === FULL_STACK ? "Pratham Saroch" :"Prachi Sengupta"}
                            hike={120}
                            course={course}
                        />
                        :
                        user === 2 ?
                            <LPJourneyCard
                                isSmallScreen={isSmallScreen}
                                src={course === FULL_STACK ? FSDUserTwo : UserTwo}
                                from={course === FULL_STACK ? "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Capgemini_201x_logo.svg/2560px-Capgemini_201x_logo.svg.png" : "https://companieslogo.com/img/orig/MPHASIS.NS_BIG-96e12b36.png?t=1720244492"}
                                to={course === FULL_STACK ? "https://companieslogo.com/img/orig/LTIM.NS-dea59dc6.png?t=1720244492" : "https://purepng.com/public/uploads/large/purepng.com-oracle-logologobrand-logoiconslogos-251519939873wlyup.png"}
                                name={course === FULL_STACK ? "Akanksha Singh" : "Aditya Venkatraman"}
                                hike={90}
                                course={course}
                            />
                            :
                            user === 3 ?
                                <LPJourneyCard
                                    isSmallScreen={isSmallScreen}
                                    src={course === FULL_STACK ? FSDUserThree : UserFour}
                                    from={course === FULL_STACK ? "https://companieslogo.com/img/orig/WIT-1453b096.png?t=1739861069" : "https://cdn.cookielaw.org/logos/628cd4f6-e459-4c91-8719-a9557855ad5c/64add6b2-304e-4af7-b8c2-8a925585cf8a/a07269fc-954a-4971-b1f6-ac7acd7aa2fe/FactSet_Logo_CMYK_Cyan.png"}
                                    to={course === FULL_STACK ? "https://www.freelogovectors.net/wp-content/uploads/2022/07/persistent-systems-logo-freelogovectors.net_.png" : "https://upload.wikimedia.org/wikipedia/commons/6/64/Intel-logo-2022.png"}
                                    name={course === FULL_STACK ? "Vivek Pandey" : "Amar Patel"}
                                    hike={83}
                                    course={course}
                                />
                                :
                                user === 4 ?
                                    <LPJourneyCard
                                        isSmallScreen={isSmallScreen}
                                        src={course === FULL_STACK ? FSDUserFour : UserFive}
                                        from={"https://clarity.microsoft.com/case-studies/wp-content/uploads/2022/11/Softr-Logo-Colour-Dark.png"}
                                        to={"https://gallerypng.com/wp-content/uploads/2024/05/tata-motors-logo-png-image.png"}
                                        name={course === FULL_STACK ? "Rajeev M" : "Renoy"}
                                        hike={65}
                                        course={course}
                                    />
                                    :
                                    <LPJourneyCard
                                        isSmallScreen={isSmallScreen}
                                        src={UserThree}
                                        from={"https://dxminds.com/wp-content/uploads/2020/05/Logo-DxMinds.png"}
                                        to={"https://images.seeklogo.com/logo-png/45/1/cred-logo-png_seeklogo-454844.png"}
                                        name={"Rohan Shinde"}
                                        hike={70}
                                        course={course}
                                    />
                    }
                </>
            }
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "2rem", marginTop: isSmallScreen && "1rem" }}>
                <Button variant="contained"
                    onClick={handleUser}
                    style={{
                        padding: "0.5rem 2rem 0.5rem 2rem",
                        color: "white",
                        textTransform: "none",
                        fontFamily: "Open Sans",
                        fontWeight: "600",
                        fontSize: "1rem",
                        margin: "1rem"
                    }}>
                    Back
                </Button>
                <Button variant="contained"
                    onClick={handleUser}
                    style={{
                        padding: "0.5rem 2rem 0.5rem 2rem",
                        color: "white",
                        textTransform: "none",
                        fontFamily: "Open Sans",
                        fontWeight: "600",
                        fontSize: "1rem",
                        margin: "1rem"
                    }}>
                    Next
                </Button>
            </div>
            <div style={{ display:!isSmallScreen && "flex", width: "100%" }}>
                <div style={{width: "15%"}}></div>
                <CareerTransitionCard value={"46LPA"} message={"Highest Salary"} isSmallScreen={isSmallScreen}/>
                <CareerTransitionCard value={"800+"} message={"Career Transition"} isSmallScreen={isSmallScreen}/>
                <CareerTransitionCard value={"5000+"} message={"Hiring Partners"} isSmallScreen={isSmallScreen}/>
                <CareerTransitionCard value={"60%"} message={"Average Salary Hike"} isSmallScreen={isSmallScreen}/>
                <div style={{width: "15%"}}></div>
            </div>
        </React.Fragment>
    );
}